import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/bauDo/ppbxv2_btn_copy.png'


const _hoisted_1 = { class: "input_container" }

import StatusPopup from '@/components/common/statusPopup.vue'
import { copyValue } from '@/view/bauDoTesouro/supportScript'
import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
    modelValue: {
        type: String,
        default: ''
    },
    labelText: {
        type: String,
        default: ''
    },
    isTopupVisible: {
        type: Boolean,
        default: false
    },
    giftAmount: {
        type: Number,
        default: 0
    }
},
  emits: ['update:modelValue', 'valueChanged'],
  setup(__props, { emit: __emit }) {

const props = __props
const statusRef = ref()
const emit = __emit

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
    localValue.value = newVal
})

watch(localValue, (val) => {
    emit('update:modelValue', val)
    emit('valueChanged', val)
})

const handleCopyValue = () => {
  copyValue(localValue.value, () => {
    statusRef.value?.open()
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      clearable: "",
      placeholder: __props.labelText,
      readonly: true
    }, {
      button: _withCtx(() => [
        _createElementVNode("img", {
          onClick: handleCopyValue,
          src: _imports_0,
          class: "left_icon",
          alt: ""
        })
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"])
  ]))
}
}

})